export default "__VITE_ASSET__C9j5Cl71__"